import React, { useEffect } from "react"
import { Grid, Nav, NavItem } from "react-bootstrap"
import { useParams, useHistory } from 'react-router-dom'

import TrainingContainer from "./TrainingContainer"
import FunctionalGroupContainer from "./FunctionalGroupContainer"
import AssignmentMetricsContainer from "./AssignmentMetricsContainer"
import DeactivatedTrainings from "./DeactivatedTrainings"
import DeactivatedFunctionalGroups from "./FunctionalGroupContainer/DeactivatedFunctionalGroups"
import './style.css'

export default function QMSTrainingManager() {
  const params = useParams()
  const history = useHistory()

  useEffect(() => {
    const tabs = [
      "trainings",
      "functional-groups",
      "assignment-metrics",
      "deactivated-trainings",
      "deactivated-functional-groups"
    ]
    if (!tabs.includes(params.tab)) {
      history.push("/manager/qms-training/trainings")
    }
  }, [params.tab, history])

  const renderActiveTab = () => {
    switch (params.tab) {
      case "trainings":
        return <TrainingContainer />
      case "functional-groups":
        return <FunctionalGroupContainer />
      case "assignment-metrics":
        return <AssignmentMetricsContainer />
      case "deactivated-trainings":
        return <DeactivatedTrainings />
      case "deactivated-functional-groups":
        return <DeactivatedFunctionalGroups />
      default:
        return null
    }
  }

  return (
    <Grid id="QMSTrainingManager">
      <Nav
        bsStyle="tabs"
        activeKey={params.tab}
      >
        <NavItem
          eventKey="trainings"
          title="Trainings"
          name="trainings"
          onClick={() => history.push("/manager/qms-training/trainings")}
        >
          Trainings
        </NavItem>
        <NavItem
          eventKey="deactivated-trainings"
          title="Deactivated Trainings"
          name="deactivated-trainings"
          onClick={() => history.push("/manager/qms-training/deactivated-trainings")}
        >
          Deactivated Trainings
        </NavItem>
        <NavItem
          eventKey="functional-groups"
          title="Functional Groups"
          name="functional-groups"
          onClick={() => history.push("/manager/qms-training/functional-groups")}
        >
          Functional Groups
        </NavItem>
        <NavItem
          eventKey="deactivated-functional-groups"
          title="Deactivated Functional Groups"
          name="deactivated-functional-groups"
          onClick={() => history.push("/manager/qms-training/deactivated-functional-groups")}
        >
          Deactivated Functional Groups
        </NavItem>
        <NavItem
          eventKey="assignment-metrics"
          title="Assignment Metrics"
          name="assignment-metrics"
          onClick={() => history.push("/manager/qms-training/assignment-metrics")}
        >
          Assignment Metrics
        </NavItem>
      </Nav>
      {renderActiveTab()}
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTrainingManager/index.js